export enum SettingCategory {
  SYSTEM = 'SYSTEM',
  EMAIL = 'EMAIL',
  SECURITY = 'SECURITY',
  BUSINESS = 'BUSINESS',
  UI = 'UI',
}

export enum SettingDataType {
  STRING = 'STRING',
  INTEGER = 'INTEGER',
  DECIMAL = 'DECIMAL',
  BOOLEAN = 'BOOLEAN',
  JSON = 'JSON',
  EMAIL = 'EMAIL',
  URL = 'URL',
  COLOR = 'COLOR',
  PASSWORD = 'PASSWORD',
}

export interface Setting {
  id: string;
  key: string;
  display_name: string;
  description: string;
  category: SettingCategory;
  category_display: string;
  value: string;
  value_display: any;
  typed_value: any;
  default_value: string;
  data_type: SettingDataType;
  data_type_display: string;
  min_value?: number;
  max_value?: number;
  choices?: any[];
  validation_regex?: string;
  is_sensitive: boolean;
  requires_restart: boolean;
  ui_group: string;
  ui_order: number;
  ui_component?: string;
  created_at: string;
  updated_at: string;
  created_by?: string;
  updated_by?: string;
}

export interface SettingHistory {
  id: string;
  setting: string;
  setting_key: string;
  setting_name: string;
  old_value: string;
  old_value_display: string;
  new_value: string;
  new_value_display: string;
  changed_by: string;
  changed_by_name: string;
  changed_at: string;
  change_reason: string;
}

export interface SettingsByCategory {
  category: SettingCategory;
  category_display: string;
  settings: Setting[];
}

export interface BulkSettingUpdate {
  settings: Array<{
    key: string;
    value: any;
  }>;
  change_reason?: string;
}

export interface SettingExportParams {
  categories?: SettingCategory[];
  include_sensitive?: boolean;
}

export interface SettingImport {
  settings: Record<string, any>;
  override_existing?: boolean;
  change_reason?: string;
}